import { ComponentProps } from 'react';
import PassengersIcon from '../../../../assets/icons/passenger.svg';
import BusinessIcon from '../../../../assets/icons/handshake.svg';
import CareersIcon from '../../../../assets/icons/suitcase.svg';
import {
	BusinessPageId,
	PassengersPageId,
} from '../../../../features/app/pages/domain/constants/PageId';

interface ISiteSectionIconProps extends ComponentProps<'svg'> {
	id: string;
}

export function SiteSectionIcon({ id, ...props }: ISiteSectionIconProps) {
	if (id === PassengersPageId.Home) return <PassengersIcon {...props} />;
	if (id === BusinessPageId.Home) return <BusinessIcon {...props} />;
	return <CareersIcon {...props} />;
}
